import angular from 'angular';

(function () {
    'use strict';

    angular.module('app.home').config(routesConfig);

    routesConfig.$inject = ['$stateProvider'];

    /* @ngInject */
    function routesConfig($stateProvider) {
        $stateProvider.state('app.home', {
            url: '/',

            component: 'home',
            resolve: {
                componentsUrls: getComponentsUrls,
            },
        });
    }
    getComponentsUrls.$inject = ['AppSvc'];
    function getComponentsUrls(AppSvc) {
        return AppSvc.getSyComponentsUrls();
    }
})();
